import { Timestamp } from 'firebase/firestore';

export enum NotificationType {
  CONNECTION_REQUEST = 'connection_request',
  CONNECTION_ACCEPTED = 'connection_accepted',
  CONNECTION_REJECTED = 'connection_rejected',
  NEW_MESSAGE = 'new_message',
  POST_LIKE = 'post_like',
  POST_COMMENT = 'post_comment',
  POST_SHARE = 'post_share',
  SYSTEM = 'system',
  SUPPORT_MESSAGE = 'support_message',
}

export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export interface NotificationData {
  connectionId?: string;
  senderId?: string;
  receiverId?: string;
  actorId?: string;
  actorName?: string;
  postId?: string;
  commentId?: string;
  sharerId?: string;
  conversationId?: string;
}

export interface FirebaseTimestamp {
  seconds: number;
  _seconds: number;
  nanoseconds: number;
  _nanoseconds: number;
}

export interface Notification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  priority: NotificationPriority;
  data: NotificationData;
  read: boolean;
  createdAt: Timestamp;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unreadCount: number;
  hasMore: boolean;
}
